module.exports = __webpack_public_path__ + "static/media/weighing-scale.a728d532.svg";